import CollapsibleList from "./CollapsibleList"

export default CollapsibleList
